import React, { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Title, Wrapper } from './ContactPersonTile.styles';
import { IScheduleSurvey } from '../../../services/surveys';
import SearchInputHeader from '../../SearchDropdown/SearchInputHeader/SearchInputHeader';

interface ContactPersonTileProps {
  schedule: IScheduleSurvey;
  updateSchedule: (updates: Partial<IScheduleSurvey>) => void;
}

const ContactPersonTile: FC<ContactPersonTileProps> = ({ schedule, updateSchedule }) => {
  const { t } = useTranslation();
  const inputRef = useRef(null);

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateSchedule({ contact_name: e.target.value });
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateSchedule({ contact_email: e.target.value });
  };

  return (
    <Container>
      <Title>{t('viewSurvey.schedule.contactPerson')}</Title>
      <Wrapper>
        <Box>
          {t('viewSurvey.schedule.personName')}
          <SearchInputHeader
            height="32px"
            active={false}
            inputRef={inputRef}
            placeholder=""
            noDrop
            defaultValue={schedule.contact_name}
            onChange={handleNameChange}
          />
        </Box>
        <Box>
          {t('viewSurvey.schedule.personEmail')}
          <SearchInputHeader
            height="32px"
            active={false}
            inputRef={inputRef}
            placeholder=""
            noDrop
            defaultValue={schedule.contact_email}
            onChange={handleEmailChange}
          />
        </Box>
      </Wrapper>
    </Container>
  );
};

export default ContactPersonTile;
